// credentials.ts
var InMemoryStorage = class {
  _data = {};
  getItem(key) {
    return this._data[key] || null;
  }
  setItem(key, value) {
    this._data[key] = value;
  }
  removeItem(key) {
    delete this._data[key];
  }
};
var DefaultCredentialsStore = class {
  _storage;
  constructor() {
    this._storage = globalThis.localStorage || new InMemoryStorage();
  }
  get accessToken() {
    return this._storage.getItem("jn:access_token") || null;
  }
  set accessToken(value) {
    if (value) {
      this._storage.setItem("jn:access_token", value);
    } else {
      this._storage.removeItem("jn:access_token");
    }
  }
  get refreshToken() {
    return this._storage.getItem("jn:refresh_token") || null;
  }
  set refreshToken(value) {
    if (value) {
      this._storage.setItem("jn:refresh_token", value);
    } else {
      this._storage.removeItem("jn:refresh_token");
    }
  }
};
export {
  DefaultCredentialsStore
};
//# sourceMappingURL=credentials.mjs.map
